<template>
    <section class="delivery-detail-item">
        <div class="info-rows">
            <div class="text-row">
                <p class="text-row-label">Type</p>
                <p class="text-row-value">{{ mailItem.mailTypeFriendly }}</p>
            </div>
            <div class="text-row">
                <p class="text-row-label">Recipient</p>
                <p class="text-row-value">{{ mailItem.customerFullName }}</p>
            </div>
            <div class="text-row">
                <p class="text-row-label">Destination</p>
                <p class="text-row-value">{{ mailItem.destinationLocatorDescription }}</p>
            </div>
            <div class="text-row">
                <p class="text-row-label">Sender</p>
                <p class="text-row-value">{{ mailItem.sender }}</p>
            </div>
            <div class="text-row">
                <p class="text-row-label">Carrier</p>
                <p class="text-row-value">{{ mailItem.mailCarrierFriendly }}</p>
            </div>
            <div class="text-row">
                <p class="text-row-label">Status</p>
                <p class="text-row-value">{{ itemDeliveryStatus }}</p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'DeliveryDetailItem',
    props: {
        mailItem: {
            type: Object,
            required: true,
        },
    },
    computed: {
        itemDeliveryStatus() {
            return this.mailItem.dateDelivered
                ? 'Delivered'
                : 'In Transit';
        },
    },
};
</script>

<style scoped lang="scss">

.delivery-detail-item {
    box-shadow: $variables-material-shadow-1;
    background: white;
    padding: 1rem;
    border-radius: 4px;
}

.info-rows {
    display: flex;
    flex-flow: column nowrap;
    >.text-row {
    }
    >*:not(:last-child) {
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid gainsboro;
    }
}
.text-row {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    >.text-row-label {
        margin-right: 1rem;
    }
}

.text-row-label {
    font-weight: 600;
    color: $colors-grey-darken-3;
}
</style>
